import type { Placement } from '@floating-ui/dom'

const hasSupport = 'anchorName' in document.documentElement.style

async function updatePositioningWithLib(
	trigger: HTMLElement,
	popover: HTMLElement,
	placement: Placement = 'bottom-end'
) {
	const { autoUpdate, computePosition, flip, offset } = await import(
		'@floating-ui/dom'
	)

	return autoUpdate(trigger, popover, () =>
		computePosition(trigger, popover, {
			middleware: [offset(10), flip()],
			placement
		}).then(({ x, y }) => {
			Object.assign(popover.style, {
				left: `${x}px`,
				top: `${y}px`
			})
		})
	)
}

export { hasSupport, updatePositioningWithLib }
